module.exports = __webpack_public_path__ + "static/media/alchemist-robes-1.8f5ba27c.glb";